/**
 * Created by dmitry on 26.08.2025
 */

const ProfileWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.avatar = cleverapps.settings.getAvatar();
        this.nickname = cleverapps.settings.getNickname();

        this._super({
            title: Messages.get("ProfileWindow.title"),
            name: "ProfileWindow",
            content: this.createContent()
        });

        this.update();
    },

    update: function () {
        this.avatars.forEach((avatar) => {
            if (this.avatar === avatar.image) {
                avatar.showBg();
                avatar.mark.setVisible(true);
            } else {
                avatar.hideBg();
                avatar.mark.setVisible(false);
            }
        });

        this.nicknameNode.setString(this.nickname);
        this.nicknameNode.fitTo(this.nicknameMaxWidth);
    },

    createContent: function () {
        const styles = cleverapps.styles.ProfileWindow;

        return new cleverapps.Layout([this.getNameGenerator(), this.getAvatarPicker(), this.getButtonsBox()], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    getNameGenerator: function () {
        const styles = cleverapps.styles.ProfileWindow.nameGenerator;

        const prefix = cleverapps.UI.generateOnlyText(
            Messages.get("ProfileWindow.name_generator_text"),
            cleverapps.styles.FONTS.PROFILE_WINDOW_NICKNAME_GENERATOR_PREFIX_TEXT
        );
        prefix.fitTo(styles.prefix.width, undefined);

        const button = new cleverapps.UI.Button({
            content: new cc.Sprite(bundles.profile_window.frames.generate_profile_icon),
            width: styles.button.width,
            height: styles.button.height,
            noBg: styles.button.noBg,
            type: styles.button.type,
            onClicked: () => {
                this.nickname = cleverapps.settings.generateName();
                this.update();
            }
        });

        const nickname = this.nicknameNode = cleverapps.UI.generateOnlyText(
            this.nickname,
            cleverapps.styles.FONTS.PROFILE_WINDOW_NICKNAME_GENERATOR_NICKNAME_TEXT
        );
        const nicknameMaxWidth = this.nicknameMaxWidth = styles.width - prefix.width - button.width - styles.margin * 2;
        nickname.fitTo(nicknameMaxWidth);
        const nicknameWrapper = cleverapps.UI.wrapWithPadding(
            nickname,
            { x: (nicknameMaxWidth - nickname.width) / 2 }
        );

        nickname.setAlignment(nickname.x + styles.nickname.offsetX, nickname.y + styles.nickname.offsetY);

        if (styles.nickname.line) {
            const line = cleverapps.UI.createScale9Sprite(bundles.profile_window.frames.line, cleverapps.UI.Scale9Rect.TwoPixelXY);
            line.setAlignment(styles.nickname.line);
            line.setContentSize2(nicknameMaxWidth, styles.nickname.line.height);
            nicknameWrapper.addChild(line);
        }

        const content = new cleverapps.Layout([prefix, nicknameWrapper, button], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        if (styles.bg) {
            const width = styles.bg.width || nicknameWrapper.width + button.width + styles.margin;
            const height = styles.bg.height || button.height - styles.bg.padding.y * 2;

            const nicknameBg = cleverapps.UI.createScale9Sprite(bundles.profile_window.frames.nickname_bg);
            nicknameBg.setContentSize2(width, height);
            nicknameBg.setAlignment(styles.bg);
            nicknameBg.setLocalZOrder(-1);
            content.addChild(nicknameBg);
        }

        return content;
    },

    getAvatarPicker: function () {
        const styles = cleverapps.styles.ProfileWindow.avatarPicker;

        const avatars = this.avatars = [];

        cleverapps.UI.Avatar.GetAvatarFramesNames().forEach((frameName) => {
            const frame = `#avatars/${frameName}.png`;

            const avatar = new cleverapps.UI.Avatar(frame, {
                padding: styles.avatarsBox.avatar.padding,
                useBigImage: true,
                useFrame: false
            });

            const mark = new cc.Sprite(bundles.profile_window.frames.avatar_mark);
            mark.setAlignment(styles.avatarsBox.avatar.mark);
            avatar.mark = mark;
            avatar.addChild(mark);

            cleverapps.UI.onClick(avatar, () => {
                cleverapps.effects.fire("profile.window.avatar.select");
                if (this.avatar !== avatar.image) {
                    this.avatar = avatar.image;
                    this.update();
                }
            });

            avatars.push(avatar);
        });

        const avatarsBox = new cleverapps.GridLayout(avatars, {
            columns: 4,
            margin: styles.avatarsBox.margin,
            padding: styles.avatarsBox.padding
        });

        const text = cleverapps.UI.generateOnlyText(Messages.get("ProfileWindow.avatar_picker_text"), cleverapps.styles.FONTS.PROFILE_WINDOW_AVATAR_PICKER_TEXT);
        text.fitTo(avatarsBox.width);

        const scroll = new cleverapps.UI.ScrollView(avatarsBox, {
            scrollBarEnabled: false,
            direction: cleverapps.UI.ScrollView.DIR_VERTICAL
        });
        scroll.setContentSize2(styles.scroll);
        scroll.scrollToDefault();
        
        const layout = new cleverapps.Layout([text, scroll], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        const scrollBorderUp = cleverapps.UI.createScale9Sprite(bundles.profile_window.frames.scroll_border, cleverapps.UI.Scale9Rect.TwoPixelXY);
        scrollBorderUp.setContentSize(scroll.width, scrollBorderUp.height);
        scrollBorderUp.setPosition(scroll.width / 2, scroll.height);
        layout.addChild(scrollBorderUp);

        const scrollBorderDown = cleverapps.UI.createScale9Sprite(bundles.profile_window.frames.scroll_border, cleverapps.UI.Scale9Rect.TwoPixelXY);
        scrollBorderDown.setContentSize(scroll.width, scrollBorderUp.height);
        scrollBorderDown.setPosition(scroll.width / 2, 0);
        layout.addChild(scrollBorderDown);

        return layout;
    },

    getButtonsBox: function () {
        const styles = cleverapps.styles.ProfileWindow.buttonsBox;

        return new cleverapps.Layout([this.getCancelButton(), this.getSaveButton()], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    getCancelButton: function () {
        const style = cleverapps.styles.ProfileWindow.button;

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            text: Messages.get("Cancel"),
            onClicked: () => this.close(),
            width: style.width,
            height: style.height
        });
    },

    getSaveButton: function () {
        const style = cleverapps.styles.ProfileWindow.button;

        return new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            text: Messages.get("Save"),
            onClicked: () => {
                cleverapps.settings.setAvatar(this.avatar);
                cleverapps.settings.setNickname(this.nickname);

                this.close();
            },
            width: style.width,
            height: style.height
        });
    },
    
    listBundles: function () {
        return ["profile_window"];
    }
});

ProfileWindow.IsSelectionAvailable = function () {
    return !connector.platform.oneOf(
        connector.OK,
        connector.VK,
        connector.OKBRIDGE,
        connector.MM,
        connector.FOTOSTRANA,
        connector.DRAUGIEM,
        connector.CRAZY
    );
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PROFILE_WINDOW_NICKNAME_GENERATOR_NICKNAME_TEXT: {
        size: 40,
        color: new cc.Color(241, 187, 143, 255)
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_PREFIX_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    PROFILE_WINDOW_AVATAR_PICKER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    }
});

cleverapps.styles.ProfileWindow = {
    padding: {
        top: 20,
        bottom: 15
    },

    margin: 30,

    nameGenerator: {
        width: 800,
        margin: 20,

        prefix: {
            width: 250
        },

        button: {
            width: 100,
            height: 80
        },

        nickname: {
            offsetX: 0,
            offsetY: 10,

            line: {
                height: 5,

                x: { align: "center" },
                y: { align: "bottom" }
            }
        }
    },

    avatarPicker: {
        margin: 30,

        avatarsBox: {
            margin: { x: 45, y: 15 },
            padding: { y: 35 },

            avatar: {
                padding: 10,
                mark: {
                    x: { align: "right", dx: 20 },
                    y: { align: "bottom", dy: -5 }
                }
            }
        },

        scroll: {
            width: 1050,
            height: 600
        }
    },

    buttonsBox: {
        margin: 120,

        padding: {
            top: 20
        }
    },

    button: {
        width: 350,
        height: 100
    }
};
